__turbopack_context__.v({
  "body": "styles-module-scss-module__74Pbwa__body",
});
